'use client';

import posthog from 'posthog-js';
import { isPostHogInitialized } from '@/instrumentation-client';
import {
  getPostHogDeploymentProperties,
  getPostHogExceptionProperties,
  type PostHogErrorProperties,
} from './posthog-errors';

type CapturePostHogClientExceptionOptions = {
  digest?: string;
  errorSource: string;
  properties?: PostHogErrorProperties;
};

export function capturePostHogClientException(
  error: unknown,
  { digest, errorSource, properties }: CapturePostHogClientExceptionOptions,
): void {
  if (!isPostHogInitialized()) return;

  try {
    posthog.captureException(
      error,
      getPostHogExceptionProperties({
        ...getPostHogDeploymentProperties(),
        ...properties,
        digest,
        error_source: errorSource,
      }),
    );
  } catch (captureError) {
    console.error(
      '[PostHog] Failed to capture client exception:',
      captureError,
    );
  }
}
